import { render, staticRenderFns } from "./ReviseSalaryApproval.vue?vue&type=template&id=397faa0c&scoped=true"
import script from "./ReviseSalaryApproval.vue?vue&type=script&lang=js"
export * from "./ReviseSalaryApproval.vue?vue&type=script&lang=js"
import style0 from "./ReviseSalaryApproval.vue?vue&type=style&index=0&id=397faa0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397faa0c",
  null
  
)

export default component.exports